module.exports = __webpack_public_path__ + "img/step-1.849d9666.png";